import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { VehiclePhotosPage } from './vehicle-photos.page';
import { VehiclePhotosPageRoutingModule } from './vehicle-photos-routing.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, VehiclePhotosPageRoutingModule],
  declarations: [VehiclePhotosPage],
})
export class VehiclePhotosPageModule {}
